"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExitCode = void 0;
exports.exitWith = exitWith;
var ExitCode;
(function (ExitCode) {
    ExitCode["VulnerabilitiesFound"] = "VULNS";
    ExitCode[ExitCode["Error"] = 2] = "Error";
    ExitCode[ExitCode["NoSupportedFiles"] = 3] = "NoSupportedFiles";
})(ExitCode || (exports.ExitCode = ExitCode = {}));
function exitWith(exitCode, message, testResults = []) {
    const err = new Error();
    err.message = message;
    err.userMessage = message;
    err.code = exitCode.valueOf();
    if (0 < testResults.length) {
        const jsonData = testResults.length === 1 ? testResults[0] : testResults;
        err.jsonStringifiedResults = JSON.stringify(jsonData);
    }
    throw err;
}
//# sourceMappingURL=error.js.map